import { createSelector } from 'reselect';
import { userSelector } from 'selectors/user/userSelector';

const isStoreIdAndZipCodeSettledSelector = createSelector(userSelector, user => {
    const userHasOwnProperty = property => Object.prototype.hasOwnProperty.call(user, property);
    const isStoreIdAndZipCodeSettled = userHasOwnProperty('preferredStore') && userHasOwnProperty('preferredZipCode');

    return isStoreIdAndZipCodeSettled;
});

export { isStoreIdAndZipCodeSettledSelector };
